import React from "react";
import fake from '../images/fake.png'

interface imageProps {
    src?:string,
    height?:number,
    radius?:number,
    [propName:string]:any
}

const ImageBox:React.FC<imageProps> = (props) => {
    return <div className="img-common-box">
        <div className="bg" style={{
            backgroundImage:`url(${ props.src || fake })`,
            paddingTop:`${ props.height || 40 }%`,
            borderRadius:`${ props.radius || 0 }px`
        }}/>
    </div>
}

export default ImageBox
